/** An absent/unknown mode must preserve every existing WhatsApp builder URL. */
export function builderMode(search: string): 'whatsapp' | 'social' {
  return new URLSearchParams(search).get('mode') === 'social' ? 'social' : 'whatsapp';
}
